<button
  *ngIf="shouldShowButton()"
  data-testId="reassign-technician-button"
  type="button"
  class="btn btn-sm btn-primary me-1 mb-1"
  (click)="onReassignClick()"
>
  {{ "measurementsGridButtonLabelReassignDoctor" | localize }}
</button>

<ng-template #templateSelectTechnician>
  <div class="modal-body text-center" data-testid="reassign-technician-dialog">
    <p class="fw-bold mb-2">{{ "reassignTechnicianModalTitle" | localize }}</p>
    <div class="mb-3">
      <select class="form-select form-select-sm" data-testid="reassign-technician-select" #technicianSelect>
        <ng-container *ngIf="doctorSelectorService.doctors | async as doctors">
          <option *ngFor="let d of doctors" [value]="d.id">{{ d.lastName }} {{ d.firstName }}</option>
        </ng-container>
      </select>
    </div>

    <div class="d-flex justify-content-center gap-2">
      <action-button
        [buttonClass]="'btn btn-primary'"
        (click)="onConfirmReassign(technicianSelect.value)"
        [testId]="'confirm-reassign-technician-button'"
        [actionInProgress]="isReassignInProgress"
        [buttonLabel]="'measurementsGridButtonLabelReassignDoctor'"
      >
      </action-button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="modalRefReassignTechnicianConfirm?.hide()"
        data-testid="cancel-reassign-technician-button"
      >
        {{ "modalResponseCancel" | localize }}
      </button>
    </div>
  </div>
</ng-template>
